import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";
// NOTE: do NOT import `attachSupabaseAuth` here — see the comment below.
// NOTE: `attachSupabaseAuth` is intentionally NOT registered. No server
// function in this project uses `requireSupabaseAuth` (admin access is gated
// by the signed admin-gate cookie), and importing the attacher pulled the
// entire supabase-js client (~600 KB raw / ~110 KB gzip) into the client
// entry bundle as unused JavaScript. Re-add it only if a server function
// starts using the Supabase auth middleware.

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware],
}));
